<template>
  <div :class="`theme-${brand.class_name || ''}`">
    <router-view />
    <alert />
    <Loader class="dass-loader" v-if="getIsLoading"/>   
  </div>
</template>

<script>
import './styles/reset.css'
import './styles/forms.scss'
import './styles/situacoes_colors.scss'
import './styles/styleSafari.scss'
import './styles/theme/theme.scss'
import Loader from '../src/components/molecules/Loader.vue'
import { mapGetters, mapActions } from 'vuex'
import Alert from './components/molecules/Alert.vue'
import requireImage from './helpers/functions/requireImage'
export default {
  name: 'App',
  components: { Alert, Loader },
  methods: {
    ...mapActions('toasts', {
      configToastPlugin: 'config',
      showToast: 'showToast'     
    }),
    ...mapActions('brand', ['switchBrand']),
    setBrandHeadTags() {      
      document.title = this.brand.name || 'Grupo Dass';
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }     
      
      const iconFile = this.brand.favicon || 'logo.png';       
      try {
        link.href = requireImage(`theme/${this.brand.folder}/${iconFile}`);
      } catch (error) {               
        link.href = requireImage(`theme/${this.brand.folder}/logo.png`);
      }
    }
  },
  created: async function () {    
    this.configToastPlugin(this.$toast)
    let current_url = window.location.href
    this.switchBrand(current_url)
    this.setBrandHeadTags()

    const rootCSS = document.querySelector(':root body')    
    rootCSS.style.setProperty('--theme-color', this.brand.color)
  },
  computed: {
    ...mapGetters('brand', { brand: 'getBrand' }),
    ...mapGetters('toasts', ['getIsLoading']),
  },
}
</script>

<style>
#app {  
  --font-body--default: var(--font-family--system);
  font-family: var(--font-family--system);  
}
.dass-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;  
  pointer-events: none;
}
.stop-scrolling {
  height: 100%;
  overflow: hidden !important;
}

/* ===== Scrollbar CSS ===== */
/* Firefox */
* {
  scrollbar-width: auto;
  scrollbar-color: var(--theme-color) #ffffff;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 10px;
}

*::-webkit-scrollbar-track {
  background: #ffffff;
}

*::-webkit-scrollbar-thumb {
  background-color: var(--theme-color);
  border-radius: 10px;
  border: 3px solid #ffffff;
}
/* Definição da animação de rotação */
@keyframes rotate-brand {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.brand-loading-overlay .q-loading__backdrop {
  background-color: rgba(0, 0, 0, 0.85) !important;
  backdrop-filter: blur(5px);
}
.brand-loading-overlay .q-loading__message {
  font-size: 1.2rem;
  font-family: 'SuaFonteMarca', sans-serif;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.brand-loading-toast {
  background: rgba(0, 0, 0, 0.9) !important;
  border: 2px solid var(--theme-color) !important;
}
.brand-loading-toast .q-notification__icon {
  width: 50px;
  height: 50px;
  animation: brand-spin 2s linear infinite;
}

@keyframes brand-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
